import { FC } from 'react'
import { FileUpload, FileUploadType } from './Upload'

export const File: FC & FileUploadType = (): JSX.Element => <></>

File.Upload = FileUpload
